module.exports = __webpack_public_path__ + "static/media/Մարիետա-Բադալյան-Հովհաննես-Թումանյան-Ախ-ինչ-լավ-է.21eb2733.mp3";